import { Box, Button, ButtonGroup } from "@chakra-ui/react";
import React from "react";
import { Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { InputControl, Optional } from "../components/Form";

export interface IRequestPasswordResetValues {
  email: string;
}

interface IRequestPasswordResetForm {
  onSubmit: (values: IRequestPasswordResetValues) => void;
  initialValues?: Optional<IRequestPasswordResetValues>;
}

export const RequestPasswordResetForm: React.FC<IRequestPasswordResetForm> = ({
    onSubmit,
    initialValues
}) => {
    const { t } = useTranslation();
    const validate = (values) => {
        const errors: { [key: string]: string } = {};

        if (!values.email) {
            errors.email = t("forms.requiredField");
        }

        return errors;
    };

    return (
        <Form
            onSubmit={ onSubmit }
            validate={ validate }
            initialValues={ initialValues }
            render={ ({
                handleSubmit,
                form,
                errors,
                submitting,
                pristine,
                values
            }) => (
                <Box as="form" p={ 2 } onSubmit={ handleSubmit }>
                    <InputControl name="email" label="E-mail" />

                    <ButtonGroup spacing={ 4 }>
                        <Button
                            isLoading={ submitting }
                            loadingText="Duke dërguar"
                            variantColor="teal"
                            type="submit"
                        >
                            { t("forms.sendResetCode") }
                        </Button>
                        <Button
                            variantColor="teal"
                            variant="outline"
                            onClick={ form.reset }
                            isDisabled={ submitting || pristine }
                        >
                            { t("forms.clear") }
                        </Button>
                    </ButtonGroup>
                </Box>
            ) }
        />
    );
};
